// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qn4xAMPXHN055mQqPyp6 {
  padding-top: 16px;
  padding-bottom: 16px
}

.iUHfUJ1HjWF4U71NroPw {
  margin-bottom: 14px
}

.FZMVXwmtE3pI1Z1jdllo {
  border-radius: 5px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1.5rem
}

.nxax3IaFcfybzpGfVcSw {
  height: 38px;
  width: 137px;
  --tw-bg-opacity: 1;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.nxax3IaFcfybzpGfVcSw:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}
.nxax3IaFcfybzpGfVcSw:disabled,
.nxax3IaFcfybzpGfVcSw[disabled] {
  cursor: not-allowed;
  border-style: none;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1)) !important
}

.nxax3IaFcfybzpGfVcSw:disabled:hover,
.nxax3IaFcfybzpGfVcSw[disabled]:hover {
  border-style: none;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1)) !important
}

._kMnLGf_VglO70PQxT9N {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem
}
.NYitgsKwIZS5vLCzB11A {
  height: 38px !important;
  width: 18rem;
  border-radius: 5px;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
._WJS1_rtS77FFUZ7ZPsi {
  overflow-x: auto;
  border-radius: 5px;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

._WJS1_rtS77FFUZ7ZPsi .ant-table-cell {
  font-size: 0.75rem;
  line-height: 1rem
}

.GxFo2REp7G4onyGQNVBq {
  display: flex;
  align-items: center;
  gap: 0.125rem
}
.hDKk_oddL57eZFhrCoPP {
  max-width: 243px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  --tw-text-opacity: 1;
  color: rgb(244 49 49 / var(--tw-text-opacity, 1))
}

._WJS1_rtS77FFUZ7ZPsi .g9JwVP7TmOm1zqpaQRGF > tr > td:nth-child(odd) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(247 251 253 / var(--tw-bg-opacity, 1)) !important
}
._WJS1_rtS77FFUZ7ZPsi .g9JwVP7TmOm1zqpaQRGF > tr > td:nth-child(even) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(247 251 253 / var(--tw-bg-opacity, 1)) !important
}

.UPkkhzohMQMnLi1Uv7wA {
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(242 250 254 / var(--tw-bg-opacity, 1));
  padding-top: 0.75rem;
  padding-bottom: 0.75rem
}

._m0R5cbaPBf2v7OqvJQk {
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: auto auto 1fr;
  align-items: flex-start;
  gap: 1rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem
}

.pm8Ghq1eGYm6FMicf6do {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-align: center
}

.dSxml7ciWlqa6N1fw9P6 {
  height: 1.5rem;
  width: 1.5rem
}

.p2SslTnhnsJjTyjkRZzL {
  font-size: 12px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}

.Wgh1Bcp_UTBf70dfYV2h {
  margin-top: 4px;
  display: flex;
  justify-content: flex-start;
  padding-left: 1.5rem;
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1))
}

.fpLTwqfpxebf0DXfaf7U {
  display: flex;
  align-items: center;
  gap: 0.5rem
}

.FAIZp0HjvF5oTOTf9y8w {
  grid-row: span 4 / span 4;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 0.75rem
}

._drL1E8DMwLHWkQN5M4K {
  height: 38px;
  width: 155px;
  --tw-border-opacity: 1;
  border-color: rgb(0 130 202 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1))
}

._drL1E8DMwLHWkQN5M4K:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 130 202 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1)) !important
}

._drL1E8DMwLHWkQN5M4K:disabled,
._drL1E8DMwLHWkQN5M4K[disabled] {
  cursor: not-allowed;
  border-style: none;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1)) !important
}

._drL1E8DMwLHWkQN5M4K:disabled:hover,
._drL1E8DMwLHWkQN5M4K[disabled]:hover {
  border-style: none;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1)) !important
}

.i6zKN0ENn5mto9xnTgPR {
  height: 38px;
  width: 307px;
  --tw-border-opacity: 1;
  border-color: rgb(0 130 202 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1))
}

.i6zKN0ENn5mto9xnTgPR:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 130 202 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1)) !important
}

.WHAmzeQR3CslBXMqenEf {
  display: flex;
  flex-direction: column;
  gap: 1rem
}
.eNJ1lho7kqfJbAqDCfYv {
  display: flex;
  gap: 1rem
}
.Yjag8zZsS3xrxnd4qE6w {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center
}
.Yjag8zZsS3xrxnd4qE6w > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse))
}

.HIkeJgEyVYrtsrUBzAVp {
  margin-left: 0.5rem;
  display: flex;
  height: 34px;
  width: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: linear-gradient(144.9deg, #ffdb52 8.6%, rgba(229, 198, 80, 0.8) 94.03%)
}

.LSIUTaGhDLWUbDO5XIKW {
  height: 9px;
  width: 17px
}
.luVjgSJINeWDKJClTUlv {
  margin-left: 0.75rem;
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(164 133 10 / var(--tw-text-opacity, 1))
}

.xZXyfACPwX4rge2Qp5vd {
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  display: flex;
  height: 47px;
  align-items: center;
  border-radius: 5px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 244 203 / var(--tw-bg-opacity, 1))
}

._WJS1_rtS77FFUZ7ZPsi .ant-checkbox .ant-checkbox-inner {
  height: 15px;
  width: 15px;
  border-radius: 2px;
  --tw-border-opacity: 1 !important;
  border-color: rgb(141 141 141 / var(--tw-border-opacity, 1)) !important
}

._WJS1_rtS77FFUZ7ZPsi .ant-checkbox-checked .ant-checkbox-inner {
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important
}

.fo7lp7SGCkycK69PLeeQ td {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1))
}

.EAmPc4YSFYhEIbbtdfJg td {
  --tw-bg-opacity: 1;
  background-color: rgb(247 251 253 / var(--tw-bg-opacity, 1))
}

.It7V75BlYSFozZjQ9Hu9 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  margin-bottom: 0.5rem;
  display: flex;
  height: 47px;
  width: 100%;
  align-items: center;
  border-radius: 5px;
  --tw-bg-opacity: 1;
  background-color: rgb(243 202 202 / var(--tw-bg-opacity, 1));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem
}

.Rer45rc9QvDJVu6Or_my {
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1))
}

.luVjgSJINeWDKJClTUlv {
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1))
}
.JijqAyX5sMKhRPgRS9Xv {
  height: 34px;
  width: 34px;
  border-radius: 5px;
  -o-object-fit: contain;
     object-fit: contain
}

.ant-checkbox-wrapper-disabled .ant-checkbox-inner,
.ant-checkbox-disabled .ant-checkbox-inner {
  --tw-border-opacity: 1;
  border-color: rgb(149 149 149 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1))
}
`, "",{"version":3,"sources":["webpack://./src/pages/Pledge/Pledge.module.css"],"names":[],"mappings":"AACE;EAAA,iBAAgB;EAAhB;AAAgB;;AAIhB;EAAA;AAAgB;;AAIhB;EAAA,kBAAiC;EAAjC,kBAAiC;EAAjC,4DAAiC;EAAjC;AAAiC;;AAIjC;EAAA,YAAkG;EAAlG,YAAkG;EAAlG,kBAAkG;EAAlG,0DAAkG;EAAlG,sBAAkG;EAAlG,eAAkG;EAAlG,gBAAkG;EAAlG,oBAAkG;EAAlG;AAAkG;;AAIlG;EAAA,6BAAgC;EAAhC,qEAAgC;EAAhC,+BAAgC;EAAhC;AAAgC;AAIhC;;EAAA,mBAAiE;EAAjE,kBAAiE;EAAjE,6BAAiE;EAAjE,uEAAiE;EAAjE,+BAAiE;EAAjE;AAAiE;;AAKjE;;EAAA,kBAA8C;EAA9C,6BAA8C;EAA9C,uEAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;;AAI9C;EAAA,qBAA+C;EAA/C,aAA+C;EAA/C,mBAA+C;EAA/C,yBAA+C;EAA/C;AAA+C;AAG/C;EAAA,uBAAkD;EAAlD,YAAkD;EAAlD,kBAAkD;EAAlD,oBAAkD;EAAlD;AAAkD;AAGlD;EAAA,gBAA8C;EAA9C,kBAA8C;EAA9C,6EAA8C;EAA9C,iGAA8C;EAA9C;AAA8C;;AAI9C;EAAA,kBAAc;EAAd;AAAc;;AAId;EAAA,aAAgC;EAAhC,mBAAgC;EAAhC;AAAgC;AAGhC;EAAA,gBAAoF;EAApF,gBAAoF;EAApF,uBAAoF;EAApF,mBAAoF;EAApF,oBAAoF;EAApF;AAAoF;;AAIpF;EAAA,6BAAyB;EAAzB;AAAyB;AAGzB;EAAA,6BAAyB;EAAzB;AAAyB;;AAIzB;EAAA,uBAAuC;EAAvC,kBAAuC;EAAvC,4DAAuC;EAAvC,oBAAuC;EAAvC;AAAuC;;AAIvC;EAAA,kBAAiE;EAAjE,aAAiE;EAAjE,oCAAiE;EAAjE,uBAAiE;EAAjE,SAAiE;EAAjE,oBAAiE;EAAjE;AAAiE;;AAIjE;EAAA,aAA0C;EAA1C,mBAA0C;EAA1C,WAA0C;EAA1C;AAA0C;;AAI1C;EAAA,cAAc;EAAd;AAAc;;AAId;EAAA,eAAyD;EAAzD,gBAAyD;EAAzD,oBAAyD;EAAzD;AAAyD;;AAIzD;EAAA,eAA2F;EAA3F,aAA2F;EAA3F,2BAA2F;EAA3F,oBAA2F;EAA3F,sBAA2F;EAA3F,eAA2F;EAA3F,gBAA2F;EAA3F,oBAA2F;EAA3F;AAA2F;;AAI3F;EAAA,aAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;;AAI9B;EAAA,yBAAoD;EAApD,aAAoD;EAApD,uBAAoD;EAApD,yBAAoD;EAApD;AAAoD;;AAIpD;EAAA,YAAkE;EAAlE,YAAkE;EAAlE,sBAAkE;EAAlE,0DAAkE;EAAlE,kBAAkE;EAAlE,4DAAkE;EAAlE,oBAAkE;EAAlE;AAAkE;;AAIlE;EAAA,iCAAkD;EAAlD,qEAAkD;EAAlD,6BAAkD;EAAlD,uEAAkD;EAAlD,+BAAkD;EAAlD;AAAkD;;AAKlD;;EAAA,mBAAiE;EAAjE,kBAAiE;EAAjE,6BAAiE;EAAjE,uEAAiE;EAAjE,+BAAiE;EAAjE;AAAiE;;AAKjE;;EAAA,kBAA8C;EAA9C,6BAA8C;EAA9C,uEAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;;AAI9C;EAAA,YAAmH;EAAnH,YAAmH;EAAnH,sBAAmH;EAAnH,0DAAmH;EAAnH,kBAAmH;EAAnH,4DAAmH;EAAnH,sBAAmH;EAAnH,eAAmH;EAAnH,gBAAmH;EAAnH,oBAAmH;EAAnH;AAAmH;;AAInH;EAAA,iCAAkD;EAAlD,qEAAkD;EAAlD,6BAAkD;EAAlD,uEAAkD;EAAlD,+BAAkD;EAAlD;AAAkD;;AAIlD;EAAA,aAA0B;EAA1B,sBAA0B;EAA1B;AAA0B;AAG1B;EAAA,aAAiB;EAAjB;AAAiB;AAGjB;EAAA,aAA0D;EAA1D,sBAA0D;EAA1D,mBAA0D;EAA1D;AAA0D;AAA1D;EAAA,uBAA0D;EAA1D,8DAA0D;EAA1D;AAA0D;;AAI1D;EAAA,mBAA4E;EAA5E,aAA4E;EAA5E,YAA4E;EAA5E,WAA4E;EAA5E,mBAA4E;EAA5E,uBAA4E;EAA5E,kBAA4E;EAC5E;AAD4E;;AAK5E;EAAA,WAAuB;EAAvB;AAAuB;AAGvB;EAAA,oBAAiF;EAAjF,sBAAiF;EAAjF,eAAiF;EAAjF,gBAAiF;EAAjF,oBAAiF;EAAjF;AAAiF;;AAIjF;EAAA,kBAAoF;EAApF,sBAAoF;EAApF,oBAAoF;EAApF,qBAAoF;EAApF,aAAoF;EAApF,YAAoF;EAApF,mBAAoF;EAApF,kBAAoF;EAApF,kBAAoF;EAApF;AAAoF;;AAIpF;EAAA,YAAuD;EAAvD,WAAuD;EAAvD,kBAAuD;EAAvD,iCAAuD;EAAvD;AAAuD;;AAIvD;EAAA,iCAAkC;EAAlC,qEAAkC;EAAlC,6BAAkC;EAAlC;AAAkC;;AAIlC;EAAA,kBAAe;EAAf;AAAe;;AAIf;EAAA,kBAAwB;EAAxB;AAAwB;;AAIxB;EAAA,oBAAwF;EAAxF,qBAAwF;EAAxF,qBAAwF;EAAxF,aAAwF;EAAxF,YAAwF;EAAxF,WAAwF;EAAxF,mBAAwF;EAAxF,kBAAwF;EAAxF,kBAAwF;EAAxF,4DAAwF;EAAxF,oBAAwF;EAAxF,qBAAwF;EAAxF,iBAAwF;EAAxF;AAAwF;;AAIxF;EAAA,sBAAmE;EAAnE,eAAmE;EAAnE,gBAAmE;EAAnE,oBAAmE;EAAnE;AAAmE;;AAInE;EAAA,sBAAmE;EAAnE,eAAmE;EAAnE,gBAAmE;EAAnE,oBAAmE;EAAnE;AAAmE;AAGnE;EAAA,YAAqD;EAArD,WAAqD;EAArD,kBAAqD;EAArD,sBAAqD;KAArD;AAAqD;;AAKrD;;EAAA,sBAAkC;EAAlC,4DAAkC;EAAlC,kBAAkC;EAAlC;AAAkC","sourcesContent":[".container {\n  @apply py-[16px];\n}\n\n.customBreadCrumbs {\n  @apply mb-[14px];\n}\n\n.mainContainer {\n  @apply bg-white rounded-[5px] p-6;\n}\n\n.applyButton {\n  @apply bg-secondary text-white w-[137px] h-[38px] text-dashboardMain font-dashboardMain font-inter;\n}\n\n.applyButton:hover {\n  @apply !bg-secondary !text-white;\n}\n.applyButton:disabled,\n.applyButton[disabled] {\n  @apply !bg-gray-100 !text-gray-300 border-none cursor-not-allowed;\n}\n\n.applyButton:disabled:hover,\n.applyButton[disabled]:hover {\n  @apply !bg-gray-100 !text-gray-300 border-none;\n}\n\n.tenantRightActions {\n  @apply flex items-center justify-end gap-3 mb-6;\n}\n.searchInput {\n  @apply rounded-[5px]  w-72 !h-[38px] text-gray-500;\n}\n.tableWrapper {\n  @apply shadow-md rounded-[5px] overflow-x-auto;\n}\n\n.tableWrapper :global(.ant-table-cell) {\n  @apply text-xs;\n}\n\n.pledgeCell {\n  @apply flex items-center gap-0.5;\n}\n.pledgeText {\n  @apply whitespace-nowrap overflow-hidden text-ellipsis max-w-[243px] text-danger-100;\n}\n\n.tableWrapper .ant-table-tbody > tr > td:nth-child(odd) {\n  @apply !bg-tableEvenRowBG;\n}\n.tableWrapper .ant-table-tbody > tr > td:nth-child(even) {\n  @apply !bg-tableEvenRowBG;\n}\n\n.expandableBG {\n  @apply bg-tableExpandBG rounded-md py-3;\n}\n\n.totalItems {\n  @apply grid grid-cols-[auto_auto_1fr] gap-4 items-start px-6 mt-6;\n}\n\n.months {\n  @apply flex items-center text-center gap-2;\n}\n\n.expandIcon {\n  @apply w-6 h-6;\n}\n\n.labelTitle {\n  @apply text-gray-600 font-dashboardMain text-dashboardSub;\n}\n\n.values {\n  @apply text-secondary text-dashboardSub font-h4 font-inter flex justify-start pl-6 mt-[4px];\n}\n\n.fullLabel {\n  @apply flex items-center gap-2;\n}\n\n.button {\n  @apply row-span-4 flex gap-3 justify-end items-start;\n}\n\n.clearButton {\n  @apply bg-white text-secondary border-secondary w-[155px] h-[38px];\n}\n\n.clearButton:hover {\n  @apply !bg-white !text-secondary !border-secondary;\n}\n\n.clearButton:disabled,\n.clearButton[disabled] {\n  @apply !bg-gray-100 !text-gray-300 border-none cursor-not-allowed;\n}\n\n.clearButton:disabled:hover,\n.clearButton[disabled]:hover {\n  @apply !bg-gray-100 !text-gray-300 border-none;\n}\n\n.viewTicket {\n  @apply bg-white text-secondary border-secondary w-[307px] h-[38px] text-dashboardMain font-dashboardMain font-inter;\n}\n\n.viewTicket:hover {\n  @apply !bg-white !text-secondary !border-secondary;\n}\n\n.buttonGroup {\n  @apply flex flex-col gap-4;\n}\n.firstGroupButton {\n  @apply flex gap-4;\n}\n.lastGroupButton {\n  @apply flex flex-col space-y-2 justify-center items-center;\n}\n\n.downloanImageBox {\n  @apply rounded-[5px] w-[34px] h-[34px] flex justify-center items-center ml-2;\n  background: linear-gradient(144.9deg, #ffdb52 8.6%, rgba(229, 198, 80, 0.8) 94.03%);\n}\n\n.downloanIcon {\n  @apply w-[17px] h-[9px];\n}\n.warningText {\n  @apply text-warningTextColor font-dashboardMain text-dashboardSub font-inter ml-3;\n}\n\n.warningCard {\n  @apply h-[47px] bg-warningCardBG rounded-[5px] mt-2 flex items-center mb-3 ml-3 mr-3;\n}\n\n.tableWrapper :global(.ant-checkbox .ant-checkbox-inner) {\n  @apply !border-gray-400 w-[15px] h-[15px] rounded-[2px];\n}\n\n.tableWrapper :global(.ant-checkbox-checked .ant-checkbox-inner) {\n  @apply !bg-primary !border-primary;\n}\n\n.evenRow td {\n  @apply bg-white;\n}\n\n.oddRow td {\n  @apply bg-tableEvenRowBG;\n}\n\n.warningContainer {\n  @apply w-full bg-danger-700 h-[47px] px-2 rounded-[5px] flex items-center mx-3 py-4 mb-2;\n}\n\n.deleteText {\n  @apply text-red-800 font-dashboardMain text-dashboardSub font-inter;\n}\n\n.warningText {\n  @apply text-red-800 font-dashboardMain text-dashboardSub font-inter;\n}\n.deleteIcon {\n  @apply w-[34px] h-[34px] object-contain rounded-[5px];\n}\n\n:global(.ant-checkbox-wrapper-disabled .ant-checkbox-inner),\n:global(.ant-checkbox-disabled .ant-checkbox-inner) {\n  @apply bg-gray-100 border-gray-300;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `qn4xAMPXHN055mQqPyp6`,
	"customBreadCrumbs": `iUHfUJ1HjWF4U71NroPw`,
	"mainContainer": `FZMVXwmtE3pI1Z1jdllo`,
	"applyButton": `nxax3IaFcfybzpGfVcSw`,
	"tenantRightActions": `_kMnLGf_VglO70PQxT9N`,
	"searchInput": `NYitgsKwIZS5vLCzB11A`,
	"tableWrapper": `_WJS1_rtS77FFUZ7ZPsi`,
	"pledgeCell": `GxFo2REp7G4onyGQNVBq`,
	"pledgeText": `hDKk_oddL57eZFhrCoPP`,
	"ant-table-tbody": `g9JwVP7TmOm1zqpaQRGF`,
	"expandableBG": `UPkkhzohMQMnLi1Uv7wA`,
	"totalItems": `_m0R5cbaPBf2v7OqvJQk`,
	"months": `pm8Ghq1eGYm6FMicf6do`,
	"expandIcon": `dSxml7ciWlqa6N1fw9P6`,
	"labelTitle": `p2SslTnhnsJjTyjkRZzL`,
	"values": `Wgh1Bcp_UTBf70dfYV2h`,
	"fullLabel": `fpLTwqfpxebf0DXfaf7U`,
	"button": `FAIZp0HjvF5oTOTf9y8w`,
	"clearButton": `_drL1E8DMwLHWkQN5M4K`,
	"viewTicket": `i6zKN0ENn5mto9xnTgPR`,
	"buttonGroup": `WHAmzeQR3CslBXMqenEf`,
	"firstGroupButton": `eNJ1lho7kqfJbAqDCfYv`,
	"lastGroupButton": `Yjag8zZsS3xrxnd4qE6w`,
	"downloanImageBox": `HIkeJgEyVYrtsrUBzAVp`,
	"downloanIcon": `LSIUTaGhDLWUbDO5XIKW`,
	"warningText": `luVjgSJINeWDKJClTUlv`,
	"warningCard": `xZXyfACPwX4rge2Qp5vd`,
	"evenRow": `fo7lp7SGCkycK69PLeeQ`,
	"oddRow": `EAmPc4YSFYhEIbbtdfJg`,
	"warningContainer": `It7V75BlYSFozZjQ9Hu9`,
	"deleteText": `Rer45rc9QvDJVu6Or_my`,
	"deleteIcon": `JijqAyX5sMKhRPgRS9Xv`
};
export default ___CSS_LOADER_EXPORT___;
